import Home from '../pages/Home';
//Rokit Admin
import RokitAdminList from '../pages/rokitAdmin/RokitAdminList';
import RokitAdminSave from '../pages/rokitAdmin/RokitAdminSave';
import RokitAdminUpdate from '../pages/rokitAdmin/RokitAdminUpdate';
//Distributor Admin
import DistributorAdminList from '../pages/distributorAdmin/DistributorAdminList';
import DistributorAdminSave from '../pages/distributorAdmin/DistributorAdminSave';
import DistributorAdminUpdate from '../pages/distributorAdmin/DistributorAdminUpdate';
import DistributorRequest from '../pages/distributorAdmin/DistributorRequest'; // add by kym
import HospitalRequest from '../pages/distributorAdmin/HospitalRequest'; // add by kym
import DistributorApprove from '../pages/distributorAdmin/DistributorApprove'; // add by kym
import HospitalApprove from '../pages/distributorAdmin/HospitalApprove'; // add by kym
import HospitalRequestList from '../pages/distributorAdmin/HospitalRequestList'; // add by kym
import DistributorRequestList from '../pages/distributorAdmin/DistributorRequestList'; // add by kym
//Hospital Admin
import HospitalAdminList from '../pages/hospitalAdmin/HospitalAdminList';
import HospitalAdminSave from '../pages/hospitalAdmin/HospitalAdminSave';
import HospitalAdminUpdate from '../pages/hospitalAdmin/HospitalAdminUpdate';
import MemberUpdate from '../pages/member/MemberUpdate';
//Template
import Template from '../pages/template/Template';
import TemplateSave from '../pages/template/TemplateSave';
import TemplateUpdate from '../pages/template/TemplateUpdate';
//Dvice
import Device from '../pages/Device/Device';
import DeviceUpdate from '../pages/Device/DeviceUpdate';
//Gcode
import Gcode from '../pages/gcode/Gcode';
import GcodeUpdate from '../pages/gcode/GcodeUpdate';
//WoundMeta
import WoundMeatList from '../pages/WoundMeta/WoundMetaList';
import WoundMetaSave from '../pages/WoundMeta/WoundMetaSave';
import WoundMetaUpdate from '../pages/WoundMeta/WoundMetaUpdate';
//Not Found
import NotFound from '../pages/NotFound';
import Maintenance from '../pages/Maintenance';
import { DirectionsTransit } from '@mui/icons-material';

export const routes = [
  { path: '/home', component: Home },
  { path: '/rokitAdminList', component: RokitAdminList },
  { path: '/saverokitAdmin', component: RokitAdminSave },
  { path: '/updaterokitAdmin/:id', component: RokitAdminUpdate },
  { path: '/distributorAdminList', component: DistributorAdminList },
  { path: '/saveDistributorAdmin', component: DistributorAdminSave },
  { path: '/updateDistributorAdmin/:id', component: DistributorAdminUpdate },
  { path: '/distributorRequest', component: DistributorRequest }, // add by kym
  { path: '/distributorApprove/:id', component: DistributorApprove }, // add by kym
  { path: '/hospitalRequest', component: HospitalRequest }, // add by kym
  { path: '/hospitalApprove/:id', component: HospitalApprove }, // add by kym
  { path: '/hospitalRequestList', component: HospitalRequestList }, // add by kym
  { path: '/distributorRequestList', component: DistributorRequestList }, // add by kym
  { path: '/hospitalAdminList', component: HospitalAdminList },
  { path: '/saveHospitalAdmin', component: HospitalAdminSave },
  { path: '/updateHospitalAdmin/:id', component: HospitalAdminUpdate },
  { path: '/updateMember/:id', component: MemberUpdate },
  { path: '/template', component: Template },
  { path: '/saveTemplate', component: TemplateSave },
  { path: '/updateTemplate/:id', component: TemplateUpdate },
  { path: '/regen', component: Gcode },
  { path: '/updateRegen/:id', component: GcodeUpdate },
  { path: '/device', component: Device },
  { path: '/updateDevice/:id', component: DeviceUpdate },
  { path: '/woundMetaList', component: WoundMeatList },
  { path: '/saveWoundMeta', component: WoundMetaSave },
  { path: '/updateWoundMeta/:id', component: WoundMetaUpdate },
  { path: '/not-found', component: NotFound },
  { path: '/maintenance', component: Maintenance },
];
